var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "scroll-rotate-container" },
    [
      _c("img", {
        staticClass: "rotating-image",
        style: { transform: `rotate(${_vm.rotationAngle}deg)` },
        attrs: { src: _vm.parsedImage.url, alt: "Rotating Image" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }